// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */

import { createAsyncAction } from 'typesafe-actions';

import { CartItem } from '../../types/Cart';

export interface CartRequestPayload {}
export interface CartSuccessPayload {
  cartItems: CartItem[];
}

export interface CartFailPayload {
  error: Error;
}

export const getCartActions = createAsyncAction(
  'elearning/GET_CART',
  'elearning/GET_CART_SUCCESS',
  'elearning/GET_CART_FAIL'
)<CartRequestPayload, CartSuccessPayload, CartFailPayload>();
